export { BootstrapApp as default } from '@modules/_bootstrap';
